import { render } from "./Step2.vue?vue&type=template&id=498066e4&scoped=true"
import script from "./Step2.vue?vue&type=script&lang=ts"
export * from "./Step2.vue?vue&type=script&lang=ts"

import "./Step2.vue?vue&type=style&index=0&id=498066e4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-498066e4"

export default script